<div class="rd-widget rd-widget-no-height-restriction estimated-rental-value-widget widget-{{widgetConfig.widgetId}}" *ngIf="widgetData">
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr class="estimated-rental-value-widget-header">
        <td colspan="6">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true" (ngModelChange)="setDirtyFlag(true)">{{ 'estimatedRentalValue.reportValuationMarketUsage' | rdTranslate }}</widget-value>
        </td>
        <td colspan="1"></td>
        <td colspan="6">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true" (ngModelChange)="setDirtyFlag(true)">{{ 'estimatedRentalValue.reportValuationMarketERVFrom' | rdTranslate }}</widget-value>
        </td>
        <td colspan="1"></td>
        <td colspan="6">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true" (ngModelChange)="setDirtyFlag(true)">{{ 'estimatedRentalValue.reportValuationMarketERVTo' | rdTranslate }}</widget-value>
        </td>
      </tr>
    </thead>
    <tbody>
      <ng-template [ngIf]="editMode">
        <tr *ngFor="let erv of widgetData.estimatedRentalValues">
          <td colspan="6">
            <widget-value [align]="'left'" [bold]="true" (ngModelChange)="setDirtyFlag(true)">{{(erv.reportValuationMarketUsage || "")}}</widget-value>
          </td>
          <td colspan="1"></td>
          <td colspan="4">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="erv.reportValuationMarketERVFrom" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
          </td>
          <td colspan="2">
            <p  *ngIf="erv.displayValuesOverTimeId == 1" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pa</p>
            <p  *ngIf="erv.displayValuesOverTimeId == 2" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pm</p>
          </td>
          <td colspan="1"></td>
          <td colspan="4">
            <pollux-report-designer-numeric-field class="widget-input-text" ngDefaultControl [(value)]="erv.reportValuationMarketERVTo" [isNullable]="true" [decimals]="2" [thousandsSeparators]="true" (valueChange)="setDirtyFlag(true)"></pollux-report-designer-numeric-field>
          </td>
          <td colspan="2">
            <p *ngIf="erv.displayValuesOverTimeId == 1"  class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pa</p>
            <p *ngIf="erv.displayValuesOverTimeId == 2"  class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pm</p>
          </td>
        </tr>
      </ng-template>
      <ng-template [ngIf]="!editMode">
        <tr *ngFor="let erv of widgetData.estimatedRentalValues">
          <td colspan="6">
            <widget-value [align]="'left'" [bold]="true" (ngModelChange)="setDirtyFlag(true)">{{(erv.reportValuationMarketUsage || "")}}</widget-value>
          </td>
          <td colspan="1"></td>
          <td colspan="1">
            <widget-value [align]="'left'" (ngModelChange)="setDirtyFlag(true)">{{(erv.reportValuationMarketERVFrom || "0")}}</widget-value>
          </td>
          <td colspan="5">
            <span *ngIf="erv.displayValuesOverTimeId == 1" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pa</span>
            <span *ngIf="erv.displayValuesOverTimeId == 2" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pm</span>
          </td>
          <td colspan="1"></td>
          <td colspan="1">
            <widget-value [align]="'left'" (ngModelChange)="setDirtyFlag(true)">{{(erv.reportValuationMarketERVTo || "0")}}</widget-value>
          </td>
          <td colspan="5">
            <span *ngIf="erv.displayValuesOverTimeId == 1" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pa</span>
            <span *ngIf="erv.displayValuesOverTimeId ==2" class="usage-measuring-values">&nbsp; {{currency}}/{{unitOfArea}} pm</span>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>
